import {createContext, useContext} from 'react'

export interface InitialSearchParamsContextValue {
  initialSearchParams: URLSearchParams
}

export const InitialSearchParamsContext = createContext<InitialSearchParamsContextValue>({
  initialSearchParams: new URLSearchParams(),
})

export const InitialSearchParamsProvider = InitialSearchParamsContext.Provider

export function useInitialSearchParams(): InitialSearchParamsContextValue {
  const context = useContext(InitialSearchParamsContext)
  if (!context) {
    throw new Error('useInitialSearchParams must be used within an InitialSearchParamsProvider')
  }
  return context
}
